export enum EnrollmentState {
  draft = "draft",
  pending = "pending",
  published = "published",
  active = "active",
  closed = "closed"
}
